export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";
